import { Link } from 'react-router-dom';

import { Link as LinkComponent } from '~/components/ui/link';
import { TextOld } from '~/components/ui/text';
import { Title, TITLE_TYPE } from '~/components/ui/title';
import { PATH } from '~/constants/route-path';
import { COLORS } from '~/styles/colors';

import {
  StyledContainer,
  StyledDescription,
  StyledImage,
  StyledImageWrapper,
  StyledTextWrapper,
  StyledTitle,
} from './styled';

const Card = ({ image, title, description }) => {
  return (
    <Link to={PATH.SIGN_UP} style={{ textDecoration: 'none' }}>
      <StyledContainer>
        <StyledImageWrapper>
          <StyledImage src={image} alt={title} />
        </StyledImageWrapper>
        <StyledTextWrapper>
          <StyledTitle>
            <Title type={TITLE_TYPE.h3} color="#292929">
              {title}
            </Title>
          </StyledTitle>
          <StyledDescription>
            <TextOld color={COLORS.grey400} fontSize={16} fontWeight={400}>
              {description}
            </TextOld>
          </StyledDescription>
          <LinkComponent to={PATH.SIGN_UP} underline fontSize={18}>
            Create QR
          </LinkComponent>
        </StyledTextWrapper>
      </StyledContainer>
    </Link>
  );
};

export default Card;
